import { Card } from 'primereact/card';
import type { CSSProperties, ReactNode } from 'react';
import styles from './card.module.css';
import { classNames } from 'primereact/utils';

type Props = {
	children?: ReactNode;
	rootClassName?: string;
	onClick?: () => void;
	style?: CSSProperties;
};

// contains card style, default padding is zero
const CardContainer = ({
	children,
	rootClassName = 'bg-white rounded-[28px] p-0 w-full',
	onClick,
	style
}: Props) => {
	return (
		<Card
			style={style}
			pt={{
				root: {
					className: classNames('shadow-none', rootClassName),
					onClick: onClick,
				},
				body: { className: styles.cardBody },
			}}
		>
			{children}
		</Card>
	);
};

export default CardContainer;
